import { Dispatch, FC, SetStateAction, } from 'react'
import { ModalComponent } from '../../../../components/Modal'
import { TableUploadPointShowDetailsWrapper } from '../table/TableUploadPointShowDetails'
import { TableResumen } from '../../../../../central/model'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  message?: TableResumen[]
  file?: any
}

const ModalErrorUpload: FC<Props> = ({ show, setShow, message = [], file }) => {

  return (
    <ModalComponent type='Alert' variant={'error'} show={show} setShow={setShow} size='lg'>
      <div>
        <p>Documento: <span>{file?.name.toUpperCase()}</span></p>
      </div>
      <div>
        {message.length>0 && <TableUploadPointShowDetailsWrapper response={message}/>}
      </div>

    </ModalComponent >
  )
}

export { ModalErrorUpload }
